<c3-config-section-box
  [title]="TP_SECTIONS_INFO['predictive-models'].label"
  [icon]="TP_SECTIONS_INFO['predictive-models'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["predictive-models"].description }}</p>

  <div [c3ConfigForm]="this">
    <app-not-yet-implemented></app-not-yet-implemented>
  </div>
</c3-config-section-box>
